import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PhoneNumberLoginService } from '../services/phone-number-login.service';
import { AppClientMetaService } from '../services/app-client-meta.service';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  private phoneNumberLoginService = inject(PhoneNumberLoginService);
  private appClientMeta = inject(AppClientMetaService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig: Record<string, string> = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    if (!req.url.startsWith(environment.ocppApiUrl)) {
      return next.handle(req.clone({ setHeaders: headersConfig }));
    }

    return from(
      Promise.all([
        this.phoneNumberLoginService.getIdToken().catch(() => null),
        this.appClientMeta.ensureLoaded(),
      ]),
    ).pipe(
      switchMap(([token]) => {
        if (token) {
          headersConfig['Authorization'] = `Bearer ${token}`;
        }
        Object.assign(headersConfig, this.appClientMeta.getHttpHeaders());
        return next.handle(req.clone({ setHeaders: headersConfig }));
      }),
    );
  }
}
